import campaigns from 'api/definitions/campaigns';
import { CAMPAIGNS_REQUEST_ACTIONS } from 'redux/modules/slot-dates/actions/types';

export const getCampaigns = () => (dispatch: WtrDispatch) =>
  dispatch({
    types: CAMPAIGNS_REQUEST_ACTIONS.triplet,
    apiCall: campaigns.get(),
  });
